import { render } from "./ObjectsNav.vue?vue&type=template&id=7a3de6c0"
import script from "./ObjectsNav.vue?vue&type=script&lang=js"
export * from "./ObjectsNav.vue?vue&type=script&lang=js"

import "./ObjectsNav.vue?vue&type=style&index=0&id=7a3de6c0&lang=scss"
import "./ObjectsNav.vue?vue&type=style&index=1&id=7a3de6c0&lang=scss"

import exportComponent from "/app/tmp/aft/V3/v2026.19.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__